import { z } from 'zod';

const imageDto = z.object({
  url: z.string().url(),
  alt: z.string().default(''),
});

export const newsSummaryDto = z.object({
  id: z.union([z.string(), z.number()]).transform(String),
  slug: z.string(),
  title: z.string().default(''),
  short_description: z.string().default(''),
  cover_image: z.string().url().nullable().default(null),
  published_at: z.string().nullable().default(null),
});

export const newsArticleDto = newsSummaryDto.extend({
  text: z.string().default(''),
  images: z.array(imageDto).default([]),
});

export const newsListDto = z.object({
  data: z.array(newsSummaryDto),
  meta: z.object({
    current_page: z.number().int().positive(),
    per_page: z.number().int().positive(),
    total: z.number().int().min(0),
    last_page: z.number().int().min(0),
  }),
});

export type NewsSummaryDto = z.infer<typeof newsSummaryDto>;
export type NewsArticleDto = z.infer<typeof newsArticleDto>;
export type NewsListDto = z.infer<typeof newsListDto>;
